<template>
  <div class="home">
    <Header v-if="isPC"></Header>
    <IndexTop v-if="!isPC"></IndexTop>
    <div class="mainbox">
      <PCFilter v-if="isPC"></PCFilter>
      <div class="box">
        <p class="btitle">热销楼盘<a @click="$router.push({path:'/estateSale'})" class="bmore">更多在售楼盘<i class="m-icon"></i></a></p>
        <HotSale class="bmain" :isPC="isPC"></HotSale>
        <p class="btitle">热门主题好房</p>
        <HotRecom class="bmain" :isPC="isPC"></HotRecom>
        <p class="btitle">猜你喜欢</p>
        <EstateList class="bmain" :isHome="true" :isPC="isPC" :eList="likeItems"></EstateList>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/components/public/Header'
import IndexTop from '@/components/public/IndexTop'
import PCFilter from '@/components/public/PCFilter'
import HotSale from '@/components/public/HotSale'
import HotRecom from '@/components/public/HotRecom'
import EstateList from '@/components/public/EstateList'
import Footer from '@/components/public/Footer'
export default {
  name: 'Home',
  components:{
    'Header': Header,
    'IndexTop': IndexTop,
    'PCFilter': PCFilter,
    'HotSale': HotSale,
    'HotRecom': HotRecom,
    'EstateList': EstateList,
    'Footer': Footer
  },
  data () {
    return {
      isPC:this.$store.state.isPC,
      likeItems:[],
    }
  },
  mounted(){
    var _this = this;
    _this.getEstate();

  },
  computed:{
    listenIsPC(){
      return this.$store.state.isPC;
    }
  },
  watch:{
    listenIsPC:function(boo){
      this.isPC = this.$store.state.isPC;
    }
  },
  methods:{
    getEstate:function(){
      this.$http.get('/api/index/getIndexGuessYouLikeList').then((response)=>{
        this.likeItems = response.data.result.estateList
      }).catch((response)=>{
        console.log(response)
      })
    },
    //获取当前城市id
    getCurrentCity:function(){
      this.$http.get('/api/index/getCurrentCitySite').then((response)=>{
        var cityExist = false;
        var cityItems = this.storage.get('cityItems');
        for (var i in cityItems) {
          if(cityItems[i].citySite == response.data.result){
            // this.$store.commit('updateCity',cityItems[i]);
            this.storage.set('city',cityItems[i]);
            cityExist = true;
          }
        }
        
        //如果定位的城市未开发，跳转到城市界面
        // if(!cityExist){
        //   this.$router.push({path:'/city'});
        // }
      }).catch((response)=>{
        console.log(response)
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Home.vue